import { createContext } from 'react';

export const CriteriaStoreContext = createContext(null);
